/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

/**
 * Slovenia-specific VAT subject subtype.
 * @nullable
 */
export type UpdateSloveniaTaxProfileBodyVatProfile = typeof UpdateSloveniaTaxProfileBodyVatProfile[keyof typeof UpdateSloveniaTaxProfileBodyVatProfile] | null;


export const UpdateSloveniaTaxProfileBodyVatProfile = {
  standard: 'standard',
  special_vat_identified: 'special_vat_identified',
  non_vat_subject: 'non_vat_subject',
} as const;
